module.exports = __webpack_public_path__ + "static/img/6.2ccc591.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/5/1/zh/6.png
// module id = S63M
// module chunks = 0